// import log4javascript from 'log4javascript';
import { logger } from '@sydney-broker-ui/utils';

const LOGGER_END_POINT = '/apps/ptb/logger';
// class BpClientLogger {
//   constructor() {
//     this.log4js = log4javascript.getLogger('clientlogs');
//     this.appender = new log4javascript.AjaxAppender(LOGGER_END_POINT);

//     this.appender.setLayout(new log4javascript.JsonLayout());
//     this.log4js.addAppender(this.appender);
//   }

//   log(message) {
//     this.log4js.info(encodeURIComponent(message));
//   }
//   trace(message) {
//     this.log4js.trace(encodeURIComponent(message));
//   }
//   debug(message) {
//     this.log4js.debug(encodeURIComponent(message));
//   }
//   info(message) {
//     this.log4js.info(encodeURIComponent(message));
//   }
//   warn(message) {
//     this.log4js.warn(encodeURIComponent(message));
//   }
//   error(message) {
//     this.log4js.error(encodeURIComponent(message));
//   }
//   fatal(message) {
//     this.log4js.fatal(encodeURIComponent(message));
//   }
// }

// const bpClientLogger = new BpClientLogger();

const bpClientLogger = logger({
  url: LOGGER_END_POINT,
  method: 'POST',
  headers: {},
  logsStoreKey: 'PTB_UI_LOGS',
  logsPerBatch: 30,
  batchInterval: 30000, // 30Sec
  timestamp: () => new Date().toISOString(),
  stacktrace: {
    levels: ['trace', 'error'],
    depth: 3,
    excess: 0,
  },
});

bpClientLogger.setLevel('trace');
export default bpClientLogger;
